<template>
  <el-dialog
    title="新增订单评论"
    :visible.sync="visible"
    width="600px"
    :close-on-click-modal="false"
    :max-height="600"
  >
    <div class="form-container">
      <el-form :model="form" label-width="90px">
        <div class="form-row">
          <el-form-item label="商品" prop="goodsId">
            <div class="upload-box small" @click="uploadGoods">
              <i class="el-icon-plus"></i>
              <span v-if="form.goodsName">{{ form.goodsName }}</span>
            </div>
          </el-form-item>
          <el-form-item label="用户头像" prop="userImage">
            <el-upload
              v-loading="userImageLoading"
              :action="uploadUrl"
              class="upload-user-image"
              :show-file-list="false"
              :before-upload="beforeUserImageUpload"
              :on-success="userImageUploadSuccess"
              :on-error="userImageUploadError"
              accept="image/jpeg,image/png,image/gif"
            >
              <img v-if="form.userImage" :src="form.userImage" class="user-image" />
              <i v-else class="el-icon-plus upload-icon"></i>
            </el-upload>
          </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item label="用户昵称" prop="userName">
            <el-input v-model="form.userName" placeholder="请输入用户昵称" class="short-input" />
          </el-form-item>
          <el-form-item label="订单ID" prop="orderId">
            <el-input v-model="form.orderId" placeholder="请输入订单ID" class="short-input" />
          </el-form-item>
        </div>
        <el-form-item label="评论内容" prop="content">
          <el-input
            type="textarea"
            v-model="form.content"
            placeholder="请输入评价内容"
            :rows="3"
            class="full-input"
          />
        </el-form-item>
        <el-form-item label="评分" prop="rating">
          <el-rate style="margin-top:10px" v-model="form.rating" :max="5" text-color="#f5a623" />
        </el-form-item>
        <el-form-item label="评论图片" prop="images">
          <el-upload
            v-loading="imagesLoading"
            :action="uploadUrl"
            class="upload-images"
            :file-list="imagesFileList"
            :before-upload="beforeImagesUpload"
            :on-success="imagesUploadSuccess"
            :on-error="imagesUploadError"
            :on-remove="imagesRemove"
            list-type="picture-card"
            :limit="9"
            accept="image/jpeg,image/png,image/gif"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <span class="image-count">最多上传9张图片</span>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addOrderReviews } from "@/api/goodsReview";

export default {
  name: "AddOrderReview",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        userName: "",
        userImage: "",
        goodsId: "",
        goodsName: "",
        orderId: "",
        rating: 0,
        content: ""
      },
      imagesList: [],
      imagesFileList: [],
      userImageLoading: false,
      imagesLoading: false,
      uploadUrl: process.env.VUE_APP_BASE_API + "/common/upload/image"
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        userName: "",
        userImage: "",
        goodsId: "",
        goodsName: "",
        orderId: "",
        rating: 0,
        content: ""
      };
      this.imagesList = [];
      this.imagesFileList = [];
    },
    uploadGoods() {
      this.$message({
        type: "info",
        message: "请选择商品"
      });
    },
    beforeUserImageUpload() {
      this.userImageLoading = true;
    },
    userImageUploadSuccess(res) {
      if (res && res.bizcode === 100) {
        this.form.userImage = res.data.url;
      } else {
        this.$message({ type: "error", message: res.msg || "头像上传失败" });
      }
      this.userImageLoading = false;
    },
    userImageUploadError() {
      this.userImageLoading = false;
      this.$message({ type: "error", message: "头像上传失败" });
    },
    beforeImagesUpload() {
      this.imagesLoading = true;
    },
    imagesUploadSuccess(res, file) {
      if (res && res.bizcode === 100) {
        const url = res.data.url;
        this.imagesList.push(url);
        this.imagesFileList.push({
          uid: file.uid,
          name: file.name,
          status: "success",
          url: url
        });
      } else {
        this.$message({ type: "error", message: res.msg || "图片上传失败" });
      }
      this.imagesLoading = false;
    },
    imagesUploadError() {
      this.imagesLoading = false;
      this.$message({ type: "error", message: "图片上传失败" });
    },
    imagesRemove(file) {
      const index = this.imagesFileList.findIndex(item => item.uid === file.uid);
      if (index > -1) {
        this.imagesFileList.splice(index, 1);
        this.imagesList.splice(index, 1);
      }
    },
    handleCancel() {
      this.$emit("update:visible", false);
    },
    handleSubmit() {
      if (!this.form.userName) {
        this.$message({ type: "warning", message: "请输入用户昵称" });
        return;
      }
      if (!this.form.goodsId) {
        this.$message({ type: "warning", message: "请选择商品" });
        return;
      }
      if (!this.form.orderId) {
        this.$message({ type: "warning", message: "请输入订单ID" });
        return;
      }
      if (!this.form.rating) {
        this.$message({ type: "warning", message: "请选择评分" });
        return;
      }
      if (!this.form.content) {
        this.$message({ type: "warning", message: "请输入评价内容" });
        return;
      }
      addOrderReviews({
        userName: this.form.userName,
        userImage: this.form.userImage || "",
        goodsId: this.form.goodsId,
        orderId: this.form.orderId,
        rating: this.form.rating,
        content: this.form.content,
        images: this.imagesList.join(",") || ""
      }).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.$message({ type: "success", message: "新增成功" });
          this.$emit("update:visible", false);
          this.$emit("success");
        } else {
          this.$message({ type: "error", message: resp.msg || "新增失败" });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.form-container {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 10px;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-row .el-form-item {
  flex: 1;
}

.upload-box {
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: #409eff;
    background-color: #f5f7fa;
  }

  &.small {
    width: 70px;
    height: 70px;
  }

  .el-icon-plus {
    font-size: 20px;
    color: #c0c4cc;
  }

  span {
    font-size: 10px;
    color: #999;
    margin-top: 2px;
    text-align: center;
    padding: 0 4px;
  }
}

.upload-user-image {
  width: 70px;
  height: 70px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: #409eff;
    background-color: #f5f7fa;
  }

  .user-image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
  }

  .upload-icon {
    font-size: 20px;
    color: #c0c4cc;
  }
}

.upload-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .el-upload--picture-card {
    width: 70px;
    height: 70px;
    line-height: 70px;
  }

  .el-upload-list--picture-card {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 0;

    .el-upload-list__item {
      width: 70px;
      height: 70px;
      margin: 0;
    }
  }
}

.image-count {
  display: block;
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.el-form-item {
  margin-bottom: 15px;
}

.el-form-item__label {
  font-weight: bold;
  font-size: 13px;
}

.short-input {
  width: 100%;
}

.full-input {
  width: 100%;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
